import styled from "styled-components";
import theme from "../../../../../styles/theme";
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  width: 100%;
  height: 100%;
  row-gap: 1vh;
  margin-top: 1vh;
  /* margin-bottom: 4vh; */
  .item {
    color: ${theme.colors.brown.primary};
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 1vw;
    place-self: center;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 16px;
  justify-content: center;
`;

export const DivSetNewOrder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  text-align: -webkit-center;
  /* height: 80vh;
  overflow-y: auto; */
  .lbl {
    margin-top: 1vh;
    color: ${theme.colors.brown.primary};
    font-size: ${theme.fontSize.md};
    margin-bottom: 1vh;
  }
  .bottom {
    margin-top: 2vh;
    color: ${theme.colors.brown.primary};
    font-size: ${theme.fontSize.mm};
    display: flex;
    align-self: center;
  }
  .details-container {
    margin-top: 1vh;
    display: flex;
    flex-direction: row;
    column-gap: 2vw;
    justify-content: center;
  }
`;

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1vh;
  align-items: center;
  justify-content: center;
  margin-top: 1vh;
  width: 70%;
  align-self: center;
  p {
    margin-top: 2vh;
    color: black;
    margin-bottom: 0vh;
    height: fit-content;
    display: flex;
    border-style: solid;
    border-width: 1px;
    border-color: black;
    padding: 13px;
    font-size: 11px;
    white-space: normal;
    overflow: hidden;
    text-overflow: clip;
    word-break: break-all;
  }
  @media ${theme.devices.tablet} {
    width: 100%;
  }
`;

export const CriterioRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    font-family: sans-serif;
    font-size: ${theme.fontSize.md};
    color: ${theme.colors.palete.brownDark};
    margin-bottom: 1vh;
    margin-top: -2vh;
    text-align: center;
    strong {
      color: black;
      font-weight: bold;
      text-transform: uppercase;
    }
    @media ${theme.devices.tablet} {
      margin-top: 0vh;
    }
  }
  .description {
    text-align: justify;
    background-color: ${theme.colors.palete.brownLight};
    padding: 10px;
    margin-top: 0vh;
    margin-bottom: 2vh;
    border-radius: 5px;
    color: white;
  }
  @media ${theme.devices.tablet} {
    overflow-y: scroll;
    height: 75vh;
  }
`;
export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  .lbl {
    align-self: center;
    font-family: sans-serif;
    font-weight: 600;
    margin-bottom: 1vh;
  }
  .form-container {
    display: flex;
    flex-direction: column;
    row-gap: 1vh;
  }
  .row-address {
    display: flex;
    flex-direction: row;
    column-gap: 1vw;
    @media ${theme.devices.tablet} {
      display: flex;
      flex-direction: column;
    }
  }
`;
